import { clsx } from "clsx";
import { History } from "lucide-react";

import { Button } from "@/components/ui/button";
import { formatBRL } from "@/lib/currency.ts";
import type { Measurement, Rollup } from "../../types.ts";
import { formatDecimalPercent } from "../../utils/format.ts";

function measuredLabel(
	percent: number | undefined,
	cents: number | undefined,
	showMoney: boolean,
): string {
	if (showMoney) return cents === undefined ? "—" : formatBRL(cents);
	return percent === undefined ? "—" : formatDecimalPercent(percent);
}

export function MeasuredCell({
	stageName,
	isLeaf,
	measurement,
	rollup,
	cancelled,
	showMoney,
	onOpenHistory,
}: {
	stageName: string;
	isLeaf: boolean;
	measurement: Measurement | undefined;
	rollup: Rollup | undefined;
	cancelled: boolean;
	showMoney: boolean;
	onOpenHistory: () => void;
}) {
	const percent = isLeaf ? measurement?.progressPercent : rollup?.percent;
	const cents = isLeaf ? measurement?.measuredCents : rollup?.measuredCents;

	return (
		<span className="measured-cell">
			<span
				className={clsx("measured-cell__value", cancelled && "is-cancelled")}
			>
				{cancelled ? "—" : measuredLabel(percent, cents, showMoney)}
			</span>
			<Button
				variant="ghost"
				size="icon"
				className="measured-cell__history"
				onClick={onOpenHistory}
				aria-label={`Histórico de medições de ${stageName}`}
			>
				<History />
			</Button>
		</span>
	);
}
